import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Form, Row } from 'reactstrap';
import FormValuesDebug from 'utils/debugTools/FormValuesDebug';
import EnergyParameterCompenent from './EnergyParameterCompenent';
import VoyageParameterComponent from './VoyageParameterComponent';
import ReportDetailsHeader from 'Components/ReportDetailsHeader';
import { useFormikContext } from 'formik';
import { saveEditForm } from 'GenericForms/Helper';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';
import AlertPopup from 'Alerts/AlertPopup';

interface ParametersStructuerType {
    setErrorMessage: any;
    toggleDynamicTabs: any;
    setRefreshKey: any;
    refreshKey: any;
    vesselMachineries: any;
    mainEngineSetting: any;
    vesselEngines: any;
    setEditValues?: any;
    editValues?: any;
    modal_backdrop?: any;
    energy_modal_backdrop?: any;
    set_energy_modal_backdrop?: any;
    set_modal_backdrop?: any;
    editInitialValues?: any;
    editSubmit?: any;
    editIsSubmitting?: any;
}

const ParametersStructure = ({
    editValues,
    setEditValues,
    setErrorMessage,
    toggleDynamicTabs,
    vesselMachineries,
    mainEngineSetting,
    vesselEngines,
    modal_backdrop,
    energy_modal_backdrop,
    set_energy_modal_backdrop,
    set_modal_backdrop,
    editSubmit,
    editIsSubmitting,
}: ParametersStructuerType
) => {
    const { previousEnggTabIndex, editReportBool, setPreviousTabIndex } = useEditReport();
    /** State variables */
    const { values, errors, touched, handleSubmit, setErrors, isSubmitting, resetForm, validateForm, setFieldTouched }:
        { values: any, errors: any, touched: any, handleSubmit: any, setErrors: any, isSubmitting: any, resetForm: any, isValid: any, validateForm: any, setFieldTouched: any } = useFormikContext<any>();
    const [alertBool, setAlertBool] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>(null);
    const [alertFieldValue, setAlertFieldValue] = useState<any>(null);
    const [alertFieldLabel, setAlertFieldLabel] = useState<any>(null);
    const [alertColourType, setAlertColourType] = useState<any>(null);
    const [alertType, setAlertType] = useState<string>(null);
    const [fieldId, setFieldId] = useState<string>(null);
    /** State variables end */

    /** UseEffect */
    useEffect(() => {
        if (
            editValues &&
            Array.isArray(editValues?.chief_engineer?.voyage_parameter) &&
            Array.isArray(editValues?.chief_engineer?.energy_parameter)
        ) {
            setEditValues({
                ...editValues,
                chief_engineer: {
                    ...editValues.chief_engineer,
                    voyage_parameter: [...values.voyageParameter],
                    energy_parameter: [...values.energyParameter],
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.voyageParameter, values.energyParameter]);
    /** UseEffect end */

    return (
        <Form
            autoComplete="off"
            onSubmit={handleSubmit}
            noValidate
            className="needs-validation"
        >
            <Card className="p-0 mb-0 border-0">
                <Card className='mb-0'>
                    <CardHeader className="p-2 ">
                        <div className="text-center">
                            <Row>
                                <Col>
                                    <h4 className="page_title pos-start mb-0">Voyage Parameters</h4>
                                    <p className="card-title-desc pos-start">
                                        All readings since last report
                                    </p>
                                </Col>
                                <Col>
                                    <ReportDetailsHeader />
                                </Col>
                            </Row>
                        </div>
                    </CardHeader>
                    <CardBody className='p-0'>
                        <VoyageParameterComponent
                            key={'VoyageParameterComponent'}
                            vesselEngines={vesselEngines}
                            mainEngineSetting={mainEngineSetting}
                            modal_backdrop={modal_backdrop}
                            setmodal_backdrop={set_modal_backdrop}
                            energy_modal_backdrop={energy_modal_backdrop}
                            setAlertBool={setAlertBool}
                            setAlertMessage={setAlertMessage}
                            setAlertFieldValue={setAlertFieldValue}
                            setAlertFieldLabel={setAlertFieldLabel}
                            setAlertColourType={setAlertColourType}
                            setAlertType={setAlertType}
                            setFieldId={setFieldId}
                            alertBool={alertBool}
                        />
                    </CardBody>
                </Card>
                <Card className='mb-0'>
                    {values?.energyParameter?.length > 0 &&
                        <React.Fragment>
                            <CardHeader className="p-2 ">
                                <div className="text-center">
                                    <Row>
                                        <Col>
                                            <h4 className="page_title pos-start mb-0">Energy Parameters</h4>
                                            <p className="card-title-desc pos-start">
                                                All readings since last report
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </CardHeader>
                            <CardBody className='p-0'>
                                <EnergyParameterCompenent
                                    key={'EnergyParameterComponent'}
                                    vesselMachineries={vesselMachineries}
                                    modal_backdrop={modal_backdrop}
                                    energy_modal_backdrop={energy_modal_backdrop}
                                    set_energy_modal_backdrop={set_energy_modal_backdrop}
                                    setAlertBool={setAlertBool}
                                    setAlertMessage={setAlertMessage}
                                    setAlertFieldValue={setAlertFieldValue}
                                    setAlertFieldLabel={setAlertFieldLabel}
                                    setAlertColourType={setAlertColourType}
                                    setAlertType={setAlertType}
                                    setFieldId={setFieldId}
                                    alertBool={alertBool}
                                />
                            </CardBody>
                        </React.Fragment>
                    }
                    <CardFooter className="p-2 py-3">
                        <Row className="d-flex align-items-center flex-row-reverse">
                            <Col lg={10}>
                                <div className="d-flex flex-wrap gap-3 justify_right">
                                    {/* {editReportBool &&
                                        <Button
                                            type="reset"
                                            color="danger"
                                            className="btn_size_cstm"
                                            onClick={() => {
                                                setEditValues({
                                                    ...editValues,
                                                    chief_engineer: {
                                                        ...editValues?.chief_engineer,
                                                        voyage_parameter: editInitialValues?.chief_engineer?.voyage_parameter,
                                                        energy_parameter: editInitialValues?.chief_engineer?.energy_parameter,
                                                    }
                                                })
                                                setRefreshKey(refreshKey + 1);
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    } */}
                                    <Button
                                        type={editReportBool ? "button" : "submit"}
                                        color="primary"
                                        className="btn_size_cstm"
                                        disabled={isSubmitting || editIsSubmitting}
                                        onClick={async () => {
                                            const validationErrors = await validateForm();
                                            (values.energyParameter || []).forEach((item: any, index: number) => {
                                                Object.keys(item).forEach((field) => {
                                                    setFieldTouched(`energyParameter[${index}].${field}`, true, false);
                                                });
                                            });
                                            (values.voyageParameter || []).forEach((item: any, index: number) => {
                                                Object.keys(item).forEach((field) => {
                                                    setFieldTouched(`voyageParameter[${index}].${field}`, true, false);
                                                });
                                            });
                                            if (editReportBool && Object.keys(validationErrors).length === 0) {
                                                await saveEditForm(editSubmit, toggleDynamicTabs, previousEnggTabIndex, setPreviousTabIndex);
                                            }
                                        }}
                                    >
                                        {(isSubmitting || editIsSubmitting) && (
                                            <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                                        )}
                                        Next <i className="bx bx-chevron-right ms-1" />
                                    </Button>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <Button
                                    type="button"
                                    color="primary"
                                    className="btn_size_cstm"
                                    onClick={() => {
                                        setErrorMessage(null);
                                        setErrors({});
                                        resetForm();
                                        toggleDynamicTabs(previousEnggTabIndex - 1);
                                    }}
                                >
                                    <i className="bx bx-chevron-left me-1" /> Previous
                                </Button>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
                <FormValuesDebug values={[values, errors, touched]} />
            </Card>
            {alertBool &&
                <AlertPopup
                    state={alertBool}
                    setState={setAlertBool}
                    alertMessage={alertMessage}
                    setAlertMessage={setAlertMessage}
                    AlertColourType={alertColourType}
                    setAlertColourType={setAlertColourType}
                    alertType={alertType}
                    setAlertType={setAlertType}
                    fieldId={fieldId}
                    formTitle="Energy Parameters"
                    fieldLabel={alertFieldLabel}
                    fieldValue={alertFieldValue}
                />
            }
        </Form>
    )
}

export default ParametersStructure